'use client';

import { Suspense } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { FavouritesProvider } from "@/context/FavouritesContext";
import { OutletProvider } from "@/context/OutletContext";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            gcTime: 1000 * 60 * 30, // 30 minutes
        },
    },
});

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            <TooltipProvider>
                <AuthProvider>
                    <OutletProvider>
                        <CartProvider>
                            <FavouritesProvider>
                                <Sonner />
                                {children}
                            </FavouritesProvider>
                        </CartProvider>
                    </OutletProvider>
                </AuthProvider>
            </TooltipProvider>
        </QueryClientProvider>
    );
}
